<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="CALL_INDEX"
        hide-actions
        class="elevation-1"
        pagination.sync="pagination"
        loading="true"
    >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.customer.name }}</td>
            <td>{{ props.item.duration }} min</td>
          </tr>
        </template>
        <template slot="no-data">
            <p>{{ $vuetify.t('$vuetify.lobis.noResultsForPosition') }}</p>
        </template>
    </v-data-table>
    <v-btn dark @click="$router.push({ name: 'CallsCreate' })">
      Hinzufügen
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CALL_INDEX } from '../../../store/actions/call'
export default {
  data () {
    return {
      headers: [
        {
          text: 'Kunde',
          align: 'left',
          value: 'customer.name'
        },
        {
          text: 'Dauer',
          align: 'left',
          value: 'minutes'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      CALL_INDEX
    ])
  },
  mounted () {
    this.$store.dispatch(CALL_INDEX)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Service/Call/Index.vue